import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const PayrollTrendChart = ({ data: liveData }) => {
  const mockTrendData = [
    { month: 'Jul', totalPayroll: 1850000, employees: 142 },
    { month: 'Aug', totalPayroll: 1920000, employees: 145 },
    { month: 'Sep', totalPayroll: 1880000, employees: 144 },
    { month: 'Oct', totalPayroll: 2050000, employees: 152 },
    { month: 'Nov', totalPayroll: 2180000, employees: 158 },
    { month: 'Dec', totalPayroll: 2350000, employees: 165 }
  ];

  const trendData = (liveData && liveData.length > 0) ? liveData : mockTrendData;

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-4 shadow-lg">
          <p className="text-sm font-medium text-foreground mb-2">{label} 2025</p>
          {payload.map((entry, index) => (
            <div key={index} className="flex items-center gap-2 text-sm">
              <div 
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: entry.color }}
              />
              <span className="text-muted-foreground">{entry.name}:</span>
              <span className="font-semibold text-foreground">
                {entry.dataKey === 'totalPayroll' 
                  ? `₹${(entry.value / 100000).toFixed(1)}L`
                  : entry.dataKey === 'avgSalary'
                  ? `₹${entry.value.toLocaleString()}`
                  : entry.value
                }
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Payroll Trends</h3>
          <p className="text-sm text-muted-foreground">Monthly payroll analysis for 2025</p>
        </div>
        <div className="text-right">
          <p className="text-sm text-muted-foreground">YTD Growth</p>
          <p className="text-lg font-semibold text-success">+23.5%</p>
        </div>
      </div>
      
      <div className="w-full h-80" aria-label="Payroll Trend Line Chart">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={trendData}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
            <XAxis 
              dataKey="month" 
              tick={{ fontSize: 12, fill: '#64748B' }}
              axisLine={{ stroke: '#E2E8F0' }}
            />
            <YAxis 
              yAxisId="payroll"
              orientation="left"
              tick={{ fontSize: 12, fill: '#64748B' }}
              axisLine={{ stroke: '#E2E8F0' }}
              tickFormatter={(value) => `₹${(value / 100000).toFixed(1)}L`}
            />
            <YAxis 
              yAxisId="employees"
              orientation="right"
              tick={{ fontSize: 12, fill: '#64748B' }}
              axisLine={{ stroke: '#E2E8F0' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ fontSize: '12px', color: '#64748B' }}
            />
            <Line 
              yAxisId="payroll"
              type="monotone" 
              dataKey="totalPayroll" 
              stroke="#3B82F6" 
              strokeWidth={3}
              dot={{ fill: '#3B82F6', strokeWidth: 2, r: 4 }}
              name="Total Payroll"
            />
            <Line 
              yAxisId="employees"
              type="monotone" 
              dataKey="employees" 
              stroke="#10B981" 
              strokeWidth={2}
              dot={{ fill: '#10B981', strokeWidth: 2, r: 3 }}
              name="Employee Count"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PayrollTrendChart;